module.exports = __webpack_public_path__ + "img/titleReason.16a25aa4.png";